export const CALL_UPDATES_POLL_TIME_MS = 6000; // 6 seconds
export const CALL_UPDATES_POLL_RETRY_TIME_MS = 6000; // 6 seconds
export const CALL_UPDATES_POLL_MAX_RETRIES = 5;

export const CALL_PING_POLL_TIME_MS = 20000; // 20 seconds
export const CALL_PING_POLL_RETRY_TIME_MS = 5000; // 5 seconds
export const CALL_PING_POLL_MAX_RETRIES = 5;

export const CALL_EXPIRY_DURATION_MS = 60000; // 1 minutes

export const CALL_CLEANUP_DELAY = 3000; // 3 seconds
